{
  "cc-migrations-tooling.confluence-agents-spotlights.done": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-count": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-one.body": [
    {
      "type": 0,
      "value": "Try a sample prompt to see how agents pull together statuses and updates for you."
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-one.title": [
    {
      "type": 0,
      "value": "See what agents can do"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-two.body": [
    {
      "type": 0,
      "value": "Use this dropdown to chat with another agent or switch back to Rovo."
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-two.title": [
    {
      "type": 0,
      "value": "Switch agents anytime"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.story.agent-name": [
    {
      "type": 0,
      "value": "Dev Assistant"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.story.prompt": [
    {
      "type": 0,
      "value": "What are best practices for software development?"
    }
  ],
  "cc-migrations-tooling.confluence-edit-with-mcp-discovery.body": [
    {
      "type": 0,
      "value": "You can update docs and space instructions automatically if MCP is enabled."
    }
  ],
  "cc-migrations-tooling.confluence-edit-with-mcp-discovery.headline": [
    {
      "type": 0,
      "value": "Edit without switching tabs"
    }
  ],
  "cc-migrations-tooling.confluence-edit-with-mcp-discovery.primary-action": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "post-office.confluence-agents-mcp-nudge-banner.body": [
    {
      "type": 0,
      "value": "Ask questions, update docs, and set space instructions without leaving your tools."
    }
  ],
  "post-office.confluence-agents-mcp-nudge-banner.call-to-action": [
    {
      "type": 0,
      "value": "Set up MCP"
    }
  ],
  "post-office.confluence-agents-mcp-nudge-banner.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.confluence-agents-mcp-nudge-banner.heading": [
    {
      "type": 0,
      "value": "Use Confluence from your AI tools"
    }
  ]
}